import { gql } from '@apollo/client';

export default gql`
  mutation DeleteMessage($input: CreateMessageInput) {
    deleteMessage(input: $input) {
      mId
    }
  }
`;
